import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import HomePage from "./HomePage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import TermsOfServicePage from "./TermsOfServicePage";
import DeleteAccountPage from "./DeleteAccountPage";

const App: React.FC = () => {
	return (
		<Router>
			<div className="app-container">
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route
						path="/privacy-policy"
						element={<PrivacyPolicyPage />}
					/>
					<Route
						path="/terms-of-service"
						element={<TermsOfServicePage />}
					/>
					<Route
						path="/delete-account"
						element={<DeleteAccountPage />}
					/>
				</Routes>
			</div>
		</Router>
	);
};

export default App;
